
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/liveChat/messageControls/messageControls.scss.css.virtualfile';
        module.exports = {"controls":"_controls_1xh4v_1","controls__left":"_controls__left_1xh4v_5","controlsLeft":"_controls__left_1xh4v_5"};